import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../services/authService';

const wrap = {
  minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)', color: '#fff',
  fontFamily: '"Poppins", sans-serif', padding: 24,
};
const card = { width: '100%', maxWidth: 420, background: '#151515', border: '1px solid #333', borderRadius: 12, padding: 28 };
const input = { width: '100%', padding: '12px 14px', borderRadius: 8, border: '1px solid #444', background: '#0f0f0f', color: '#fff', marginTop: 8 };
const btn = { width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: '#4c8bf5', color: '#fff', fontWeight: 600, cursor: 'pointer', marginTop: 16 };

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // {ok, message}
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await resetPassword(email.trim());
    setStatus({ ok: result.success, message: result.success ? result.message : (result.error || 'Something went wrong.') });
    setLoading(false);
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Reset your password</h1>
        <p style={{ opacity: 0.7, marginBottom: 16 }}>Enter your account email and we'll send you a reset link.</p>
        {status && (
          <p style={{ color: status.ok ? '#4caf50' : '#ff6b6b', marginBottom: 12 }}>{status.message}</p>
        )}
        <form onSubmit={submit}>
          <label htmlFor="email">Email address</label>
          <input id="email" type="email" required style={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          <button type="submit" style={btn} disabled={loading}>{loading ? 'Sending…' : 'Send reset link'}</button>
        </form>
        <p style={{ marginTop: 16, textAlign: 'center' }}><Link to="/login" style={{ color: '#4c8bf5' }}>Back to sign in</Link></p>
      </div>
    </div>
  );
}
